var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmergencyDoorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10556",
    "data-name": "Group 10556",
    transform: "translate(-140 -1010)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6850",
    "data-name": "Rectangle 6850",
    width: 40,
    height: 40,
    rx: 5,
    transform: "translate(140 1010)",
    fill: "#398eb4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Scanner",
    transform: "translate(147 1017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Emergency-Door",
    d: "M13.981,2,13.8,2.02l-10,2a1,1,0,0,0-.788.805L3,5V22.994a1,1,0,0,0,.635.931l.169.049,10,2a1,1,0,0,0,1.18-.8L15,24.994V3l-.016-.177a1,1,0,0,0-1-.823ZM17,4V6h4V21.994H17v2h5a1,1,0,0,0,.984-.82l.016-.18V5a1,1,0,0,0-.82-.984L22,4Zm-4,.22V23.774l-8-1.6V5.82ZM10,13a1,1,0,1,0,1,1A1,1,0,0,0,10,13Z",
    fill: "#fff",
    opacity: 0.8
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyDoorIcon);
export default __webpack_public_path__ + "static/media/EmergencyDoorIcon.179b6657f81e6f42ba3b1f88103879c9.svg";
export { ForwardRef as ReactComponent };